import React from 'react';
import TradeDashboard from './TradeDashboard';

function App() {
  return (
    <div className="App">
      <TradeDashboard />
    </div>
  );
}

export default App;
